//React
import React from 'react';
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';




class Comp extends React.Component {
  render() {
    let hnIcon;
    let ssIcon;
    let snIcon;
    let dsIcon;
    let crIcon;

    if (this.props.my.proof.person === 1) {
    	hnIcon = (<span className='proof_icon'>本人証明</span>);
    }
    else {
      hnIcon = (<Link to="/my/proof/person"><span className='proof_icon_no'>本人証明</span></Link>);
    }
    if (this.props.my.proof.photo ===  1) {
    	ssIcon = (<span className='proof_icon'>写真証明</span>);
    }
    else {
      ssIcon = (<Link to="/my/proof/photo"><span className='proof_icon_no'>写真証明</span></Link>);
    }
    if (this.props.my.proof.income ===  1) {
    	snIcon = (<span className='proof_icon'>収入証明</span>);
    }
    else {
      snIcon = (<Link to="/my/proof/income"><span className='proof_icon_no'>収入証明</span></Link>);
    }
    if (this.props.my.proof.single === 1) {
    	dsIcon = (<span className='proof_icon'>独身証明</span>);
    }
    else {
      dsIcon = (<Link to="/my/proof/single"><span className='proof_icon_no'>独身証明</span></Link>);
    }

    if (this.props.my.profile.userdata_sex === 'men') {
      if (this.props.my.proof.credit === 1) {
      	crIcon = (<span className='proof_icon'>クレジット証明</span>);
      }
      else {
        crIcon = (<Link to="/setting/charge/"><span className='proof_icon_no'>クレジット証明</span></Link>);
      }
    }

  	return (
      <div
        style={{
          display:'flex',
          flexDirection:'row',
          flexWrap: 'wrap',
          textAlign:'center',
          alignItems:'center',
          justifyContent:'center',
          margin:'5px',
        }}
      >
        { hnIcon }
        { ssIcon }
        { snIcon }
        { dsIcon }
        { crIcon }
      </div>
  	)
  }
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
